import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-home-banner',
  imports: [CarouselModule, CommonModule,  ],
  templateUrl: './home-banner.component.html',
  styleUrl: './home-banner.component.scss',
})
export class HomeBannerComponent {
  userLoggedIn = false;
  @Input() bannerList: any;
  isBannerLoaded: boolean = false;
  customOptions: OwlOptions = {
    loop: false,
    autoplay: true,
    autoplayTimeout: 10000, // Set 10-second interval
    center: false,
    dots: true,
    nav: false,
    // navText: [
    //   '<img ngSrc="assets/images/ic_arrow_left.svg" class="arrow__icon" alt="Previous" />',
    //   '<img ngSrc="assets/images/ic_arrow_left.svg" class="arrow__icon right" alt="Next" />',
    // ],
    autoHeight: false,
    autoWidth: false,
    items: 1,
    // singleItem: true,
    // responsive: {
    //   0: {
    //     items: 1,
    //   },
    // },
  };
  @Output() scrollToSection = new EventEmitter<void>();


  fileDirectoriesPath: any = fileDirectories.profile;
  constructor(
    private _apiService: ApiCallsService,
    private _userService: UserService,
  ) {
    // this._apiService.loader(true);
    this._userService
      .getUser()
      .pipe()
      .subscribe((user) => {
        if (user) {
          this.userLoggedIn = true;
        } else this.userLoggedIn = false;
        // this._getBannerList();
      });
  }

  private _getBannerList(): void {
    // this._apiService.loader(true);
    this._apiService.get(api._banner, {}).subscribe({
      next: (res: any) => {
        this.bannerList = res?.data?.rows;
        this.isBannerLoaded = true;
      },
      error: (error: any) => console.log(error),
    });
  }

  trackBySlide(index: number, item: any): any {
    return item.isCloned ? `cloned-${item.id ?? index}` : (item.id ?? index);
  }
  triggerScroll() {
    this.scrollToSection.emit();
  }
}
